export default defineNuxtRouteMiddleware(() => {
  const companyId = localStorage.getItem('cid')
  const companies = JSON.parse(localStorage.getItem('companies') || '[]')
  const isAdmin = companies.find(
    ({ id }: { id: number }) => id === Number(companyId),
  )?.is_member_admin
  const { $store } = useNuxtApp()

  if (!isAdmin) {
    return navigateTo($store.auth.isLoggedIn ? '/dashboard/home' : '/')
  }
})
